import script from "./field-set.vue?vue&type=script&setup=true&lang=js"
export * from "./field-set.vue?vue&type=script&setup=true&lang=js"

import "./field-set.vue?vue&type=style&index=0&id=5b81b521&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b81b521"]])

export default __exports__